export default __webpack_public_path__ + "static/media/nantes8.53cd0f3d.jpg";